module.exports = __webpack_public_path__ + "img/bottom-tips.3ab42157.png";